import { v4 as uuid } from 'uuid';
import type { IAssetFinanceCommitment } from './AssetFinanceAssetCommitment.interface';
import { epoch, formatEpochAsDate, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';

export default class AssetFinanceCommitment implements IAssetFinanceCommitment {
  id: string;
  idReference: string;
  asset: string;
  lender: string;
  lenderOtherName: string;
  dateTakenOut: string;
  netAmountFinanced: number;
  facility: number;
  rate: number;
  term: number;
  repayments: number;
  currentMarketValue: number;
  outstanding: number;
  residualValueBalloon: number;
  accountNumber: string;
  toBePaidOut: boolean;

  getSetDateTakenOut(timeZone, locale, localeFormat) {
    return formatEpochAsDate(this.dateTakenOut, timeZone, locale, localeFormat);
  }

  getDateTakenOut(timeZone, locale, localeFormat) {
    return this.dateTakenOut
      ? formatEpochAsDate(this.dateTakenOut, timeZone, locale, localeFormat)
      : 'N/A';
  }

  static build = (data: IAssetFinanceCommitment) => new AssetFinanceCommitment(data);
  static blank = () => new AssetFinanceCommitment();

  constructor(data?: IAssetFinanceCommitment) {
    this.id = toUUID(data?.id) || uuid();
    this.idReference = toUUID(data?.idReference);
    this.asset = data?.asset || '';
    this.lender = data?.lender || '';
    this.lenderOtherName = data?.lenderOtherName || '';
    this.dateTakenOut = data?.dateTakenOut ? epoch(utc(data?.dateTakenOut)) : 0;
    this.netAmountFinanced = parseFloat(data?.netAmountFinanced || 0);
    this.facility = parseInt(data?.facility || 0, 10);
    this.rate = parseFloat(data?.rate || 0);
    this.term = parseInt(data?.term || 0, 10);
    this.repayments = parseFloat(data?.repayments || 0);
    this.currentMarketValue = parseFloat(data?.currentMarketValue || 0);
    this.outstanding = parseFloat(data?.outstanding || 0);
    this.residualValueBalloon = parseFloat(data?.residualValueBalloon || 0);
    this.accountNumber = data?.accountNumber || '';
    this.toBePaidOut = data?.toBePaidOut === true;
  }
}
